import React from 'react';
import { useTranslation } from 'react-i18next';

// styles
import * as Styled from 'teamProfiles/styles/TeamEmptyState.style';
import * as Text from 'theme/components/Text.style';

export default function TeamEmptyState(): JSX.Element {
  const { t } = useTranslation('pageTeam');

  return (
    <Styled.EmptyStateContainer>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Text.H6>{t('teamPage.noTeamMembers')}</Text.H6>
        <Text.P3>{t('teamPage.noTeamMembersText')}</Text.P3>
      </div>
    </Styled.EmptyStateContainer>
  );
}
